






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { SO_FAR } from '@/store/mutation-types'
import moment from 'moment'
import { start } from 'nprogress'

@Component({})
export default class SoFarPicker extends Vue {
	private open = false
	private actualRange: any = []
	private pickerRange: any = []
	// 保存日期选择器选中的首个值
	private startDates: any = []
	private soFarDisabled = true

	@Prop({})
	private initialValue!: any

	@Prop({ default: false })
	private disabled!: boolean

	@Prop({ default: 'YYYY-MM-DD' })
	private dateFormat!: string

	private get displayRange() {
		if (this.actualRange && this.actualRange.length > 0) {
			const start = this.actualRange[0].format(this.dateFormat)
			const end =
				this.actualRange[1].valueOf() >= SO_FAR
					? '至今'
					: this.pickerRange[1].format(this.dateFormat)
			return `${start} ~ ${end}`
		} else {
			return ''
		}
	}

	@Watch('initialValue', { immediate: true })
	private onInitialChange() {
		if (!this.initialValue) {
			return
		}

		this.pickerRange = this.actualRange = this.initialValue
	}

	@Watch('actualRange', { immediate: true })
	private onRangeChange() {
		this.$emit('rangeChange', this.actualRange)
	}

	private onSelectSoFar() {
		this.open = false
		this.pickerRange = this.actualRange = [...this.startDates, moment(SO_FAR)]
	}

	private handleOpenChange(open: boolean) {
		this.open = open
		if (open) {
			this.soFarDisabled = true
			// 结束日期为至今时 调整结束日期日期选择器为开始时间 因为至今会导致选中2050年
			if (this.pickerRange && this.pickerRange.length > 0) {
				const startTime = this.pickerRange[0],
					endTime = this.pickerRange[1]
				if (endTime.valueOf() >= SO_FAR) {
					this.pickerRange = [startTime, startTime]
				}
			}
		} else {
			this.pickerRange = this.actualRange
		}
	}

	private onCalendarChange(dates: any) {
		if (dates && dates.length === 1) {
			this.startDates = dates
		} else if (dates && dates.length === 2) {
			this.pickerRange = this.actualRange = dates
		}
		this.soFarDisabled = (dates && dates.length) !== 1
	}
}
